function capitalizeFirstLetter(str: string) {
  if (!str) return '' // Handle empty string or null case
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}


export {capitalizeFirstLetter}